import React from 'react';
import { isArray } from 'lodash';

class Band extends React.PureComponent {

  render() {
    const { uid, cellPath, fill } = this.props;

    const isGradient = isArray(fill);
    const _fill = isGradient ? 'transparent' : fill;
    const _style = {};
    if(isGradient) {
      _style.fill = `url("#${uid}-band-gradient")`;
    }

    return (
      <g>

        {isGradient && 
          <defs>
            <linearGradient id={`${uid}-band-gradient`} x1="0%" y1={uid === 2 ? "100%" : "0%"} x2="100%" y2={uid === 3 ? "100%" : "0%"}>
              <stop offset="0%" style={{stopColor: fill[0], stopOpacity: 1}}></stop>
              <stop offset="100%" style={{stopColor: fill[1], stopOpacity: 1}}></stop>
            </linearGradient>
          </defs>
        }

        <path d={cellPath} fill={_fill} strokeWidth="0" style={_style} />

      </g>
    )
  }
}

export default Band;


// WEBPACK FOOTER //
// ./src/components/cell/band.js